// extracted by mini-css-extract-plugin
export default {"buttonContainer":"TlAriC","buttonContent":"efLPUk"};